export default {
      id: "color_person-usage",
      viewBox: "0 0 57 72",
      url: __webpack_public_path__ + "sprite.svg#color_person",
      toString: function () {
        return this.url;
      }
    }